import { AuFilterOptionsListName } from '@shared/ui-components/au-configurable-filter/selectable-options.service';
import { IAuFilterFieldsConfig } from '@shared/ui-components/au-configurable-filter/interfaces/au-configurable-filter.interfaces';

export const AssetsBuildingFilterFields: IAuFilterFieldsConfig = {
	firstSelect: {
		placeholder: 'Buildings',
		formControlName: 'buildingsId',
		checkAllPlaceholder: 'all_buildings',
		listOfOptions: AuFilterOptionsListName.buildings,
	},
	secondSelect: {
		placeholder: 'Tenants',
		formControlName: 'tenants',
		checkAllPlaceholder: 'all_tenants',
		listOfOptions: AuFilterOptionsListName.tenants,
	},
	searchField: {
		formControlName: 'search',
	},
};

export const DashboardBuildingFilterFields: IAuFilterFieldsConfig = {
	firstSelect: {
		placeholder: 'Buildings',
		formControlName: 'buildingsId',
		checkAllPlaceholder: 'all_buildings',
		listOfOptions: AuFilterOptionsListName.buildings,
	},
	secondSelect: {
		placeholder: 'Statuses',
		formControlName: 'statuses',
		checkAllPlaceholder: 'all_statuses',
		listOfOptions: AuFilterOptionsListName.buildingKpiStatuses,
	},
	searchField: {
		formControlName: 'search',
	},
};

export const BuildingComfortFields: IAuFilterFieldsConfig = {
	firstSelect: {
		placeholder: 'Floors',
		formControlName: 'floorId',
		checkAllPlaceholder: 'all_floors',
		listOfOptions: AuFilterOptionsListName.floors,
	},
	secondSelect: {
		placeholder: 'Comfort level',
		formControlName: 'comfortLevel',
		checkAllPlaceholder: 'all_comfort_levels',
		listOfOptions: AuFilterOptionsListName.comfortStatuses,
	},
	searchField: {
		formControlName: 'search',
	},
};

export const BuildingTechStatusField: IAuFilterFieldsConfig = {
	firstSelect: {
		placeholder: 'Status',
		disableMultipleSelection: true,
		defaultValue: 'any',
		formControlName: 'systemRun',
		listOfOptions: AuFilterOptionsListName.techStatuses,
	},
	secondSelect: {
		placeholder: 'Predictive Maintenance',
		formControlName: 'predictive',
		checkAllPlaceholder: 'all_statuses',
		listOfOptions: AuFilterOptionsListName.predictiveMaintenance,
	},
	searchField: {
		formControlName: 'search',
	},
};
